import { cn } from '@/utils/cn'
import { type VariantProps, cva } from 'class-variance-authority'

const statisticsTileVariants = cva('flex flex-col gap-1 rounded-xl border bg-surface px-4 py-3', {
  variants: {
    size: {
      sm: '[&_.stat-value]:text-2xl',
      lg: '[&_.stat-value]:text-4xl',
    },
  },
  defaultVariants: {
    size: 'sm',
  },
})

interface StatisticsTileProps extends VariantProps<typeof statisticsTileVariants> {
  label: string
  value: string | number
  subtitle?: string
  className?: string
}

export function StatisticsTile({ label, value, subtitle, size, className }: StatisticsTileProps) {
  return (
    <div className={cn(statisticsTileVariants({ size }), className)}>
      <p className="text-xs">{label}</p>
      <p className="stat-value font-medium text-heading-foreground">{value}</p>
      {subtitle && <p className="mt-1 text-xs">{subtitle}</p>}
    </div>
  )
}
